import NotificationService from '../services/NotificationService'

const notificationServicePlugin = {
  install(Vue: any) {
    Vue.prototype.$notificationService = new NotificationService(
      Vue.prototype.$snotify,
    )
  },
}

export default notificationServicePlugin
